module.exports = __webpack_public_path__ + "img/high-level.be0cc0ef.png";